import { observer } from "mobx-react-lite";
import { useLocation } from "react-router-dom";

import { useActiveStructuredSearchSchema } from "@/components/StructuredSearch/hooks/useActiveStructuredSearchSchema";
import {
  REQUESTS_TABLE_URL_NAMESPACE,
  TRACES_TABLE_URL_NAMESPACE,
} from "@/components/StructuredSearch/hooks/structuredSearchUrlNamespaces";
import { useStructuredSearchURLSync } from "@/components/StructuredSearch/hooks/useStructuredSearchURLSync";
import { useStructuredSearchStore } from "@/components/StructuredSearch";
import { useApplyOlderDataConstraints } from "@/routes/request-logs/search/hooks/useApplyOlderDataConstraints";
import {
  isWorkspaceAnalyticsPathname,
  isWorkspaceRequestLogsTablePathname,
  isWorkspaceTracesAnalyticsPathname,
  isWorkspaceTracesSearchPathname,
} from "@/utils/workspacePathMatchers";

export const WorkspaceStructuredSearchBootstrap = observer(() => {
  const structuredSearchStore = useStructuredSearchStore();
  const { pathname } = useLocation();
  const isTracesTableSurface =
    isWorkspaceTracesSearchPathname(pathname) || isWorkspaceTracesAnalyticsPathname(pathname);
  const isRequestsTableSurface =
    isWorkspaceRequestLogsTablePathname(pathname) || isWorkspaceAnalyticsPathname(pathname);
  // Table namespaces sync only on their surfaces. Sidebar/prompt own separate namespaces.
  const shouldSyncUrl = isRequestsTableSurface || isTracesTableSurface;
  const urlNamespace = isTracesTableSurface
    ? TRACES_TABLE_URL_NAMESPACE
    : REQUESTS_TABLE_URL_NAMESPACE;

  useActiveStructuredSearchSchema();
  useApplyOlderDataConstraints();
  useStructuredSearchURLSync(structuredSearchStore, shouldSyncUrl, urlNamespace);

  return null;
});
